import React from 'react';
import { useTranslation } from 'react-i18next';

import { Plus } from 'lucide-react';

interface AddLuminaireButtonProps {
  onClick: () => void;
  variant?: 'md' | 'full';
  className?: string;
  disabled?: boolean;
}

export const AddLuminaireButton: React.FC<AddLuminaireButtonProps> = ({
  onClick,
  variant = 'full',
  className = '',
  disabled = false,
}) => {
  const { t } = useTranslation();

  const baseStyles =
    'border border-gray-600 text-gray-300 text-sm font-medium flex items-center justify-center gap-2 transition-colors';
  const variantStyles = variant === 'md' ? 'rounded-md px-4 py-2' : 'rounded-full px-6 py-2';
  const stateStyles = disabled
    ? 'opacity-50 cursor-not-allowed grayscale'
    : 'hover:border-gray-500 hover:text-gray-200 cursor-pointer';

  return (
    <button
      onClick={(e) => {
        e.stopPropagation();
        if (!disabled) onClick();
      }}
      className={`${baseStyles} ${variantStyles} ${stateStyles} ${className}`}
      title={disabled ? t('workspace.addLuminaireManuallyDisabled') : t('workspace.addLuminaireManually')}
      disabled={disabled}
    >
      <Plus size={14} />
      <span>{t('workspace.addLuminaireManually')}</span>
    </button>
  );
};
